import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import { MapProvider } from 'react-map-gl'
import MapStateProvider from './state/MapStateProvider'
import LocalizationStateProvicer from './state/LocalizationStateProvider'
import AuthStateProvider from './state/AuthStateProvider'
import Root from './screens/Root'
import './App.css'

const noop = () => {}

if (process.env.NODE_ENV !== 'development') {
	console.log = noop
	console.warn = noop
	console.error = noop
}

const App = () => (
	<BrowserRouter basename='map'>
		<MapProvider>
			<AuthStateProvider>
				<MapStateProvider logIt={process.env.NODE_ENV === 'development'}>
					<LocalizationStateProvicer>
						<Root />
					</LocalizationStateProvicer>
				</MapStateProvider>
			</AuthStateProvider>
		</MapProvider>
	</BrowserRouter>
)

export default App
